import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Button from '../button';
import { i18n } from 'core/i18n';
import './dialog.css'

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='down' ref={ref} {...props} />;
});
const styles = {
	closeButton: {
		position: 'absolute',
		right: '5px',
		top: '3px',
		borderRadius: '4px'
	},
};
class DialogComponent extends Component {
	// constructor(props) {
	// 	super(props);
	// }
	render() {
		const { props } = this,
			{
				children = null,
				open,
				onRequestClose,
				title = null,
				actionsStyle,
				actionsClassName,
				fullWidth,
				fullScreen,
				maxWidth = 'sm',
				dialogId,
				onClose,
				onConfirmClick,
				onCloseClick,
				showConfirmButton = true,
				actions = [
					<Button
						size='large'
						className='close-button'
						style={{ width: '100%' }}
						onClick={onCloseClick}
					>
						{i18n('close')}
					</Button>,
					<Button
						size='large'
						className={`primary-button ${showConfirmButton ? '' : 'disabled-button'}`}
						style={{ width: '100%' }}
						onClick={onConfirmClick}
						disabled={!showConfirmButton}
					>
						{i18n('confirm')}
					</Button>
				],
			} = props;
		return (
			<Dialog
				open={open}
				fullWidth={fullWidth}
				fullScreen={fullScreen}
				maxWidth={maxWidth}
				onClose={onRequestClose}
				aria-labelledby='form-dialog-title'
				id={dialogId}
				className='dialog-component'
				transitionDuration={400}
				TransitionComponent={Transition}
			>
				{
					title ? (
						<DialogTitle id='form-dialog-title' className='dialog-component-header'>
							{title}
							{
								onClose ? (
									<IconButton aria-label='close' style={styles.closeButton} onClick={onClose}>
										<CloseIcon />
									</IconButton>
								) : null
							}
						</DialogTitle>
					) : null
				}

				<DialogContent className='dialog-component-body'>
					{children}
				</DialogContent>
				{
					actions ? (
						<DialogActions className='dialog-component-footer'>
							{
								actions.map((a, i) => {
									return <span style={actionsStyle} className={`dialog-action ${actionsClassName}`} key={i}>{a}</span>;
								})
							}
						</DialogActions>
					) : null
				}
			</Dialog>
		);
	}
}
export default DialogComponent;
